export default "__VITE_ASSET__dtIrlCnk__"